export interface IHomeCard {
  id: number
  icon: string
  title: string
  description: string
  columns: number
  label: string
  route: object
  labelColor?: string
  iconColor?: string
  onClick?: () => void
}

export interface IRequestFormData {
  productId: string
  bpn: string
  message: string
}

export interface IPcfReqParams {
  name: string
  productId: string
  bpn: string
  minCreatedAt: string
  maxCreatedAt: string
  page: number
  size: number
  sort: any
}
export type PcfFilterKeys = Extract<
  keyof IPcfReqParams,
  "productId" | "bpn" | "minCreatedAt" | "maxCreatedAt"
>

export enum EnumPcfReqStates {
  REQUESTED = "REQUESTED",
  REPLIED = "REPLIED",
  RECEIVED = "RECEIVED",
  APPROVED = "APPROVED",
  UPDATE_PUSHED = "UPDATE_PUSHED",
  ASPECT_NOT_FOUND = "ASPECT_NOT_FOUND",
  FAILED_TO_REPLY = "FAILED_TO_REPLY",
  FAILED_TO_REQUEST = "FAILED_TO_REQUEST"
}

export const IPcfReqStates = {
  [EnumPcfReqStates.REPLIED]: "violet",
  [EnumPcfReqStates.REQUESTED]: "yellow",
  [EnumPcfReqStates.RECEIVED]: "blue",
  [EnumPcfReqStates.APPROVED]: "green",
  [EnumPcfReqStates.UPDATE_PUSHED]: "green",
  [EnumPcfReqStates.ASPECT_NOT_FOUND]: "red",
  [EnumPcfReqStates.FAILED_TO_REPLY]: "red",
  [EnumPcfReqStates.FAILED_TO_REQUEST]: "red"
}

export function getPcfReqStateColor(state: EnumPcfReqStates) {
  return IPcfReqStates[state]
}

export enum EnumReqTypes {
  PROVISION = "provisions",
  CONSUMPTION = "consumptions",
  PUBLISHED = "Published",
  CONSUMED = "Consumed",
  PROVIDED = "Provided"
}

export enum EnumPcfPageTypes {
  REQUESTS = "Requests",
  RESPONSES = "Responses"
}

export enum EnumPcfPageNames {
  PCF_PROVIDE = "pcf_provide",
  PCF_CONSUME = "pcf_consume",
  PCF_REQUESTS = "pcf_requests",
  PCF_HISTORY = "pcf_history"
}
